import React, { useContext, useState } from 'react';
import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';
import enrollmentAction from '../../../../../../providers/EnrollmentContextProvider/enrollmentAction';
import FormUAF from './StepsForm';
import PreviewUAFForm from './StepsForm/PreviewUAFForm';
import UAFInfo from '../../UAFFormInfo';

const UAFForm = ({ onFinish }) => {
  const [showsPreview, setShowsPreview] = useState(false);

  const { dispatch, areUafInstructionsRead } = useContext(EnrollmentContext);

  const startUafForm = () => {
    dispatch({ type: enrollmentAction.ACCEPT_UAF_INSTRUCTIONS, payload: true });
  };

  const showPreview = () => {
    setShowsPreview(true);
  };

  if (areUafInstructionsRead) {
    if (showsPreview) {
      return <PreviewUAFForm onFinish={onFinish} />;
    }

    return <FormUAF onFinish={showPreview} />;
  }

  return (
    <div>
      <UAFInfo />
      <Row gutter={[40]}>
        <Col lg={12} xs={24}>
          <Button
            className="enrollmentLegalFormContainer__button"
            type="primary"
            onClick={() => startUafForm()}
          >
            Completar Formulario UAF
          </Button>
        </Col>
        {/* <Col lg={12} xs={24}>
          <Button
            className="enrollmentLegalFormContainer__button"
            type="primary"
            onClick={() => onFinish()}
            ghost
          >
            Continuar al siguiente paso
          </Button>
        </Col> */}
      </Row>
    </div>
  );
};

UAFForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default UAFForm;
